import { render, staticRenderFns } from "./otherContractDetail.vue?vue&type=template&id=57ba91e4"
import script from "./otherContractDetail.vue?vue&type=script&lang=js"
export * from "./otherContractDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports